/* eslint-disable import/prefer-default-export */
/* eslint-disable multiline-ternary */
import styled, { css } from 'styled-components';

import Typography from '../../base/Typography';
import { Col } from '../../base/Grid';

export const AccoladesSection = styled.section`
  ${({ theme, containerStyles }) => {
    const desktop = theme.useMediaQuery(theme.breakpoints.up('medium'));
    return css`
        padding-top: ${desktop ? theme.spacing(12.5).rem() : theme.spacing(10).rem()};
        padding-bottom: ${desktop ? theme.spacing(12.5).rem() : theme.spacing(10).rem()};
        ${containerStyles}
      `;
  }}
`;

export const HeadingCol = styled(Col)`
${({ theme }) => {
    const desktop = theme.useMediaQuery(theme.breakpoints.up('medium'));
    return css`
      margin-bottom: ${desktop ? theme.spacing(10).rem() : theme.spacing(5).rem()};
    `;
  }}
`;

const getAccoladeContent = (theme) => {
  const small = theme.useMediaQuery(theme.breakpoints.up('small'));
  const medium = theme.useMediaQuery(theme.breakpoints.up('medium'));
  let margin = '1rem 0';
  if (medium) {
    margin = `1rem ${theme.spacing(10).rem()} 0`;
  } else if (small) {
    margin = `1rem ${theme.spacing(5).rem()}`;
  }
  return css`
    margin: ${margin};
  `;
};

export const AccoladeContainer = styled.div`
  ${({ theme }) => { getAccoladeContent(theme); }}
`;
export const AccoladeContainerBlockquote = styled.div`
  ${({ theme }) => { getAccoladeContent(theme); }}
`;

export const AccoladeTitleTypography = styled(Typography)`
${({ theme }) => css`
      ::after {
        display: block;
        width: ${theme.spacing(15).rem()};
        padding-bottom: ${theme.spacing(4).rem()};
        border-bottom: ${theme.spacing(1).rem()} solid ${theme.colors.cta.yellow};
        margin: 0 auto ${theme.spacing(4).rem()};
        content: '';
    }`
}
`;
